<template>
    <modal
        :name="'descripcion-' + evento_id"
        transition="pop-out"
        :width="800"
        height="auto"
        scrollable
        :id="'descripcion-' + evento_id"
        :adaptive="true"
        class="modal_info"
    >
        <div class="p-3">
            <p v-html="descripcion"></p>
            <p v-if="politica_menores" v-html="politica_menores"></p>
            <p v-if="politica_menores">{{ $t('general.hoja_responsabilidad') }}
                <strong>
                    <a
                        href="https://storage.compralaentrada.com/autorizaciones/compralaentrada-autorizacion-menores.pdf"
                        target="_blank"
                    >
                        <p style="color: black;">{{ $t('general.aqui') }}.</p>
                    </a>
                </strong>
            </p>
            <button class="button large-button effect-button sitecolor-content d-flex align-items-center justify-content-center" @click.prevent="close">Cerrar</button>
        </div>
    </modal>
</template>

<script>
    export default {
        props: ['evento_id', 'descripcion', 'politica_menores'],
        data() {
            return {}
        },
        methods: {
            close() {
                this.$emit('close', 'descripcion-' + this.evento_id);
            },
        },
    }
</script>

<style scoped>
    .modal_info {
        overflow-y: auto;
        align-items: center;
        justify-content: center;
    }
</style>